import React, { Dispatch, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

import { resetUserPassword } from 'actions/userActions';
import { useAppDispatch } from 'hooks';
import { User } from 'reducers/userReducer';
import GeneratedPasswordTextBox from './GeneratedPasswordTextBox';

const ResetUserPasswordPopup = ({
  resetPassword,
  setResetPassword,
  onClose,
  user,
}: {
  resetPassword: boolean;
  setResetPassword: Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
  user: User;
}) => {
  const dispatch = useAppDispatch();

  const [pending, setPending] = useState<boolean>(false);
  const [newPassword, setNewPassword] = useState<string>('');

  const reset = () => {
    if (newPassword.length > 0) {
      resetUserPassword(user.username!, newPassword).then(
        () => {
          setPending(false);
          setResetPassword(false);
          dispatch({ type: 'SUCCESS', message: `password reset successfully` });
        },
        () => {
          setPending(false);
          dispatch({ type: 'ERROR', message: 'Error resetting password' });
        }
      );
    }
  };

  function randomPassword() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 16; i += 1) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    setNewPassword(result);
  }

  useEffect(() => {
    randomPassword();
  }, []);

  return (
    <Modal show={resetPassword}>
      <Modal.Header>
        <Modal.Title>Reset password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ textAlign: 'right' }}>
          <Form.Group as={Row}>
            <Form.Label column sm={12} className="font-weight" style={{ textAlign: 'start' }}>
              You&apos;re resetting the password of user: <b>{user.username!}</b>
            </Form.Label>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={4} className="font-weight-bold" style={{ textAlign: 'start' }}>
              New user password
            </Form.Label>

            <Col sm={8}>
              <GeneratedPasswordTextBox password={newPassword} setPassword={setNewPassword} generate={randomPassword} />
            </Col>
          </Form.Group>
          <Button onClick={pending ? () => {} : onClose} variant="outline-secondary" style={{ minWidth: '6em' }}>
            Cancel
          </Button>
          <Button onClick={reset} style={{ minWidth: '6em', marginLeft: '0.7em' }}>
            Ok
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResetUserPasswordPopup;
